module.exports = __webpack_public_path__ + "static/media/error.15933c14.svg";